
import Constants from 'expo-constants';
//import AWS from 'aws-sdk';


import { Amplify } from 'aws-amplify';
import awsConfig from '../aws-config';
import { uploadData } from '@aws-amplify/storage';

Amplify.configure(awsConfig);

/*AWS.config.update({
    region: Constants.expoConfig?.extra?.AWS_REGION,
    accessKeyId: Constants.expoConfig?.extra?.AWS_APIKEY,
    secretAccessKey: Constants.expoConfig?.extra?.AWS_SEC_APIKEY,
});

const s3 = new AWS.S3();*/

export const uploadFile = async (uriFrenteINE, id_empresa, id_activacion, tipo_imagen) => {
  /*return new Promise((resolve, reject) => {
        fetch(uriFrenteINE)
          .then(response => response.blob())
          .then(blob => {
            const params = {
              Bucket: Constants.expoConfig?.extra?.AWS_BUCKET_IMAGES,
              Key: key,
              Body: blob,
              ContentType: contentTypeData,
            };
    
            s3.upload(params, (err, data) => {
              if (err) {
                //console.log('Error uploading image:', err);
                reject({"Success": false, "Error": err});
              } else {
                //console.log('Successfully uploaded image:', data);
                resolve({"Success": true, "Message": "Successfully uploaded image", "data": data});
              }
            });
          })
          .catch(error => {
            console.error('Error:', error);
            reject({"Success": false, "Error": err});
          });
      });*/

}

export const uploadFileSign = async (blob, id_empresa, id_activacion, tipo_imagen) => {
  try{
    let key = "";
    let contentTypeData = "";
    key = `${id_activacion}/firma_${id_empresa}_${id_activacion}_${tipo_imagen}.jpg`;
    contentTypeData = 'image/jpeg';

    const { key: resultKey } = await uploadData({
      key: key,
      data: blob,
      options: {
        contentType: 'image/jpeg',
        accessLevel: 'public',
        metadata: { id_empresa, id_activacion, tipo_imagen }
      }
    }).result;

    const fileUrl = `https://${awsConfig.Storage.S3.bucket}.s3.${awsConfig.Storage.S3.region}.amazonaws.com/public/${resultKey}`;

    return {
      Success: true,
      Message: "Successfully uploaded image",
      data: {
        key: resultKey,
        Location: `${fileUrl}`
      }
    };
  } catch (error) {
    console.error('Error en uploadFile:', error);
    return {
      Success: false,
      Error: error.message
    };
  }

}

export const uploadFileSignPer = async (blob, id_empresa, id_activacion, tipo_imagen) => {
  /*let key = "";
  let contentTypeData = "";
  key = `${id_activacion}/firma_${id_empresa}_${id_activacion}_${tipo_imagen}.jpg`;
  contentTypeData = 'image/jpeg';

  return new Promise((resolve, reject) => {
      const params = {
        Bucket: Constants.expoConfig?.extra?.AWS_BUCKET_IMAGES,
        Key: key,
        Body: blob,
        ContentType: contentTypeData,
      };
  
      s3.upload(params, (err, data) => {
        if (err) {
          //console.log('Error uploading image:', err);
          reject({"Success": false, "Error": err});
        } else {
          //console.log('Successfully uploaded image:', data);
          resolve({"Success": true, "Message": "Successfully uploaded image", "data": data});
        }
      });
    });*/

}
